import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Reservation } from 'src/app/model/reservation';
import * as fromReservationList from '../reducers/reservation-list.reducer';

export const selectReservationListState = createFeatureSelector<fromReservationList.State>(
  fromReservationList.reservationListFeatureKey
);

export const selectAllReservations = createSelector(selectReservationListState, state => state.reservations);
export const selectDate = createSelector(selectReservationListState, state => state.date);
export const selectEditingReservationId = createSelector(selectReservationListState, state => state.editingReservationId);
export const selectEditingReservation = createSelector(
  selectEditingReservationId,
  selectAllReservations,
  (selectedReservationId: string | null, allReservations: Reservation[]) => {
    if (selectedReservationId && allReservations) {
      return allReservations.find((res: Reservation) => res.reservationDetails.reservationId === selectedReservationId);
    } else {
      return null;
    }
  }
);
export const selectShifts = createSelector(selectReservationListState, state => state.shifts);
export const selectReservationsAndProcessedShifts = createSelector(selectReservationListState, state => {
  const { reservations, processedShifts } = state;
  return { reservations, processedShifts };
});
export const selectBlockingInterval = createSelector(selectReservationListState, state => state.blockingInterval);
export const selectBlockingPurpose = createSelector(selectReservationListState, state => state.blockingPurpose);
export const selectBlockingCategory = createSelector(selectReservationListState,state => state.blockingCategory);
export const selectProcessedShifts = createSelector(selectReservationListState, state => state.processedShifts);
export const selectPendingReservations = createSelector(selectReservationListState, state => state.pendingReservations);
export const selectPendingActionsNumber = createSelector(selectReservationListState, state => state.pendingReservations.length);
export const selectRefreshListInterval = createSelector(selectReservationListState, state => state.refreshListInterval);
export const expandedReservationIds = createSelector(selectReservationListState, state => state.expandedReservationIds);
export const selectGlobalSearchTerm = createSelector(selectReservationListState, state => state.globalSearchTerm);
export const selectSortType = createSelector(selectReservationListState, state => state.sortType);
export const selectSortDesc = createSelector(selectReservationListState, state => state.sortDesc);
export const selectCachedReservationsList = createSelector(selectReservationListState, state => state.cachedReservationsLists);
export const selectFilters = createSelector(selectReservationListState, state => state.filters);
export const selectSelectedShift = createSelector(selectReservationListState, state => state.selectedShift);
export const selectCompactView = createSelector(selectReservationListState, state => state.compactView);
export const selectOrderDetailsReservationId = createSelector(selectReservationListState, state => state.rerervationIdForOrderDetails);
export const selectScrollTop = createSelector(selectReservationListState, state => state.scrollTop);
